// The 12 report types (CLAUDE.md Section 31 / Phase 5 brief), in the order
// shown on screen. `key` matches TspApiService.reports' REPORT_PATHS key —
// see api/tspApiService.js.
export const REPORT_TYPES = [
  { key: "journeys", label: "Journey Report" },
  { key: "teams", label: "Team Report" },
  { key: "states", label: "State Report" },
  { key: "cities", label: "City Report" },
  { key: "distribution", label: "Distribution Report" },
  { key: "books", label: "Book-wise Report" },
  { key: "publicResponse", label: "Public Response Report" },
  { key: "contacts", label: "Contact Report" },
  { key: "accommodation", label: "Accommodation Report" },
  { key: "media", label: "Media Report" },
  { key: "activity", label: "Activity Report" },
];

export const EXPORT_FORMATS = [
  { key: "csv", label: "CSV" },
  { key: "xlsx", label: "Excel" },
  { key: "pdf", label: "PDF" },
];
